export const MAP_SETTINGS_DRAWING_SYNC_SETTINGS = 'MAP_SETTINGS_DRAWING_SYNC_SETTINGS';
